module.exports = __webpack_public_path__ + "672a083c550c9c17481e97778bbab7e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/local-stories.png
// module id = 1311
// module chunks = 47